// Long enough to outlast a slow WS echo, short enough that a genuine remote update converges quickly.
export const OPTIMISTIC_MOVE_GUARD_TTL_MS = 6000;

interface OptimisticMoveRecord {
  taskSubgroupId: string | null;
  orderKey?: string;
  expiresAt: number;
}

interface OptimisticMoveInput {
  taskSubgroupId: string | null;
  orderKey?: string;
}

const optimisticMoves = new Map<string, OptimisticMoveRecord>();

export function recordOptimisticMove(
  entryId: string,
  move: OptimisticMoveInput,
): void {
  optimisticMoves.set(entryId, {
    ...move,
    expiresAt: Date.now() + OPTIMISTIC_MOVE_GUARD_TTL_MS,
  });
}

export function getOptimisticMove(
  entryId: string,
): OptimisticMoveRecord | undefined {
  const record = optimisticMoves.get(entryId);
  if (!record) {
    return undefined;
  }
  if (record.expiresAt <= Date.now()) {
    optimisticMoves.delete(entryId);
    return undefined;
  }
  return record;
}

export function clearOptimisticMove(entryId: string): void {
  optimisticMoves.delete(entryId);
}
